module.exports = __webpack_public_path__ + "static/media/explore_01.77cd7841.jpg";